export default "__VITE_ASSET__7otGpL2l__"